import React from 'react';
import {Modal, TouchableOpacity, View} from 'react-native';
import CCText from '@/Atoms/CCText';
import CCButton from '@/Atoms/CCButton';
import {confirmStyles} from './styles';
import {CouponConfirmDialogProps} from './types';

const WarningIcon = () => (
  <View style={confirmStyles.iconContainer}>
    <View
      style={{
        width: 28,
        height: 28,
        borderRadius: 14,
        backgroundColor: '#FACF47',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
      <CCText
        style={{
          fontSize: 16,
          color: '#4D3F37',
          fontFamily: 'DMSans-Bold',
          lineHeight: 20,
          marginTop: -2,
        }}>
        !
      </CCText>
    </View>
  </View>
);

export default function CouponConfirmDialog({
  pendingCoupon,
  appliedCoupon,
  basePrice,
  currentDiscountLabel,
  currentDiscountedPrice,
  pendingDiscountedPrice,
  onConfirm,
  onCancel,
}: CouponConfirmDialogProps) {
  const currentLabel =
    currentDiscountLabel ?? appliedCoupon?.code ?? 'Current Discount';

  console.log('Dialog render', {
    pendingCoupon,
    appliedCoupon,
    currentDiscountLabel,
    currentDiscountedPrice,
    pendingDiscountedPrice,
    basePrice,
  });
  const visible =
    !!pendingCoupon &&
    currentDiscountedPrice != null &&
    pendingDiscountedPrice != null;

  if (!visible) {
    return null;
  }

  const extra = (
    (pendingDiscountedPrice as number) - (currentDiscountedPrice as number)
  ).toFixed(2);
  const currentSavingsLabel = `Saves ₹${(
    (basePrice as number) - (currentDiscountedPrice as number)
  ).toFixed(2)}`;
  const newSavingsLabel = `Saves only ₹${(
    (basePrice as number) - (pendingDiscountedPrice as number)
  ).toFixed(2)}`;

  return (
    <Modal
      transparent
      animationType="fade"
      visible={visible}
      statusBarTranslucent>
      <View style={confirmStyles.overlay}>
        <View style={confirmStyles.card}>
          <WarningIcon />

          <CCText fontWeight="semibold" style={confirmStyles.title}>
            Your current discount saves more
          </CCText>

          <CCText style={confirmStyles.subtitle}>
            {"You'd pay "}
            <CCText fontWeight="bold" style={confirmStyles.subtitle}>
              ₹{extra} more
            </CCText>
            {' if you switch from '}
            <CCText
              fontWeight="semibold"
              style={[confirmStyles.subtitle, {color: '#262322'}]}>
              {currentLabel}
            </CCText>
            {' to '}
            <CCText
              fontWeight="semibold"
              style={[confirmStyles.subtitle, {color: '#262322'}]}>
              {pendingCoupon!.code}
            </CCText>
            {". We'll keep the better one for you unless you say otherwise."}
          </CCText>

          {/* Comparison box */}
          <View style={confirmStyles.compareBox}>
            {/* Best row — current discount */}
            <View
              style={[confirmStyles.compareRow, confirmStyles.compareRowBest]}>
              <View style={confirmStyles.rowLeft}>
                <CCText style={[confirmStyles.pill, confirmStyles.pillBest]}>
                  Best
                </CCText>
                <View style={confirmStyles.rowLeftText}>
                  <CCText style={confirmStyles.rowCode}>{currentLabel}</CCText>
                  <CCText style={confirmStyles.rowSavings}>
                    {currentSavingsLabel}
                  </CCText>
                </View>
              </View>
              <View style={confirmStyles.rowRight}>
                <CCText
                  style={[confirmStyles.rowPrice, confirmStyles.rowPriceBest]}>
                  ₹{currentDiscountedPrice}
                </CCText>
                <CCText style={confirmStyles.rowPriceLabel}>You pay</CCText>
              </View>
            </View>

            {/* New row — pending coupon */}
            <View style={confirmStyles.compareRow}>
              <View style={confirmStyles.rowLeft}>
                <CCText style={confirmStyles.pill}>New</CCText>
                <View style={confirmStyles.rowLeftText}>
                  <CCText style={confirmStyles.rowCode}>
                    {pendingCoupon!.code}
                  </CCText>
                  <CCText style={confirmStyles.rowSavings}>
                    {newSavingsLabel}
                  </CCText>
                </View>
              </View>
              <View style={confirmStyles.rowRight}>
                <CCText
                  style={[confirmStyles.rowPrice, confirmStyles.rowPriceNew]}>
                  ₹{pendingDiscountedPrice}
                </CCText>
                <CCText style={confirmStyles.delta}>+₹{extra}</CCText>
              </View>
            </View>
          </View>

          {/* Actions */}
          <View style={confirmStyles.actions}>
            <CCButton onPress={onCancel} isRounded>
              Keep {currentLabel} (₹{currentDiscountedPrice})
            </CCButton>
            <TouchableOpacity onPress={onConfirm} activeOpacity={0.7}>
              <CCText style={confirmStyles.switchLink}>
                Switch to {pendingCoupon!.code} anyway
              </CCText>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
}
